export const CKYC_FLOWS_QUERY_KEY = ["ckycFlows"];

// Selector options in display order; `flag` is the GET /ckyc/flows field that enables each one.
export const KYC_FLOW_OPTIONS = [
  {
    view: "doc-chooser",
    flag: "upload_doc_enabled",
    title: "Option A - Upload Documents",
    subtitle: "Aadhaar, PAN photo uploads (JPG, PNG, PDF)",
  },
  {
    view: "verify",
    flag: "verify_enabled",
    title: "Option B - Verify with PAN/Aadhaar Number",
    subtitle: "Instant verification using ID numbers and redirect flow",
  },
];

export const KYC_UNAVAILABLE_MSG = "KYC verification is currently unavailable, please contact support";

// Backend 400 message fragment when a flow was switched off after /ckyc/flows was read.
export const KYC_FLOW_DISABLED_TEXT = "is disabled";
